import * as React from 'react';

type TooltipState = {
    x: number;
    y: number;
    element?: React.ReactNode;
};

type UseSvgTooltipOptions = {
    delay?: number;
};

export function useSvgTooltip({ delay = 0 }: UseSvgTooltipOptions = {}) {
    const [tooltip, setTooltip] = React.useState<TooltipState>({
        x: 0,
        y: 0,
        element: null,
    });

    const delayTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

    const showTooltip = (
        e: React.MouseEvent<SVGElement>,
        element: React.ReactNode
    ) => {
        if (delayTimerRef.current) clearTimeout(delayTimerRef.current);

        const x = e.clientX + 10;
        const y = e.clientY + 10;

        if (delay > 0) {
            delayTimerRef.current = setTimeout(() => {
                setTooltip({ x, y, element });
            }, delay);
        } else {
            setTooltip({ x, y, element });
        }
    };

    const hideTooltip = () => {
        if (delayTimerRef.current) clearTimeout(delayTimerRef.current);
        setTooltip(prev => ({ ...prev, element: null }));
    };

    const Tooltip = () => (
        tooltip.element ? (
            <div
                style={{
                    position: 'fixed',
                    top: tooltip.y,
                    left: tooltip.x,
                    pointerEvents: 'none',
                    zIndex: 9999,
                }}
            >
                {tooltip.element}
            </div>
        ) : null
    );

    return { showTooltip, hideTooltip, Tooltip };
}
